var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons 18/18px",
    clipPath: "url(#clip0_8422_3787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Checkmark",
    d: "M5.31 7.29539L4.05 8.55539L8.1 12.6054L17.1 3.60539L15.84 2.34539L8.1 10.0404L5.31 7.29539ZM16.2 9.00539C16.1935 10.5061 15.7162 11.9669 14.8354 13.182C13.9546 14.3971 12.7147 15.3051 11.2905 15.778C9.86621 16.251 8.32944 16.2651 6.89676 15.8183C5.46408 15.3715 4.20773 14.4864 3.30481 13.2877C2.40188 12.089 1.8979 10.6371 1.86391 9.13677C1.82992 7.63643 2.26762 6.16324 3.11534 4.92487C3.96305 3.68649 5.17801 2.74537 6.58899 2.23415C7.99996 1.72294 9.53579 1.66741 10.98 2.07539L12.375 0.675389C11.3089 0.21907 10.1596 -0.0107864 9 0.000388777C7.21997 0.000388777 5.47991 0.52823 3.99987 1.51716C2.51983 2.5061 1.36628 3.9117 0.685088 5.55624C0.00389969 7.20077 -0.174331 9.01037 0.172936 10.7562C0.520203 12.502 1.37737 14.1057 2.63604 15.3644C3.89472 16.623 5.49836 17.4802 7.24419 17.8275C8.99002 18.1747 10.7996 17.9965 12.4442 17.3153C14.0887 16.6341 15.4943 15.4806 16.4832 14.0005C17.4722 12.5205 18 10.7804 18 9.00039L16.2 9.00539Z",
    fill: "#21872D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8422_3787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdded);
export default __webpack_public_path__ + "static/media/added.ceed8fc3e6c24978a0de053d2af0ece9.svg";
export { ForwardRef as ReactComponent };